// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"2c3280b5","453":"8328d2e9"}[chunkId] + ".chunk.js";
};